module.exports = __webpack_public_path__ + "static/media/RENTABILIDAD_F2.73463cdd.svg";